import { render, staticRenderFns } from "./app-debug.vue?vue&type=template&id=51fc7c7a"
import script from "./app-debug.vue?vue&type=script&lang=js"
export * from "./app-debug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports